import { makeStyles, withStyles } from '@material-ui/core/styles'
import Badge from '@material-ui/core/Badge'

const drawerWidth = 190

export const styles = makeStyles((theme) => ({
  // Global
  fullwidth: {
    maxWidth: 'fill-content',
    padding: theme.spacing(2),
    marginButtom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      flex: 1
    }
  },
  m1: {
    margin: theme.spacing(1)
  },
  m2: {
    margin: theme.spacing(2)
  },
  m3: {
    margin: theme.spacing(3)
  },
  m4: {
    margin: theme.spacing(4)
  },
  p1: {
    padding: theme.spacing(1)
  },
  p2: {
    padding: theme.spacing(2)
  },
  p3: {
    padding: theme.spacing(3)
  },
  p4: {
    padding: theme.spacing(4)
  },
  mb1: {
    marginBottom: theme.spacing(1)
  },
  mb2: {
    marginBottom: theme.spacing(2)
  },
  mb3: {
    marginBottom: theme.spacing(3)
  },
  mb4: {
    marginBottom: theme.spacing(4)
  },
  mt1: {
    marginTop: theme.spacing(1)
  },
  mt2: {
    marginTop: theme.spacing(2)
  },
  mt3: {
    marginTop: theme.spacing(3)
  },
  mt4: {
    marginTop: theme.spacing(4)
  },
  ml1: {
    marginLeft: theme.spacing(1)
  },
  ml2: {
    marginLeft: theme.spacing(2)
  },
  ml3: {
    marginLeft: theme.spacing(3)
  },
  ml4: {
    marginLeft: theme.spacing(4)
  },
  mr1: {
    marginRight: theme.spacing(1)
  },
  mr2: {
    marginRight: theme.spacing(2)
  },
  mr3: {
    marginRight: theme.spacing(3)
  },
  mr4: {
    marginRight: theme.spacing(4)
  },
  pb1: {
    paddingBottom: theme.spacing(1)
  },
  pb2: {
    paddingBottom: theme.spacing(2)
  },
  pb3: {
    paddingBottom: theme.spacing(3)
  },
  pb4: {
    paddingBottom: theme.spacing(4)
  },
  pt1: {
    paddingTop: theme.spacing(1)
  },
  pt2: {
    paddingTop: theme.spacing(2)
  },
  pt3: {
    paddingTop: theme.spacing(3)
  },
  pt4: {
    paddingTop: theme.spacing(4)
  },
  pl1: {
    paddingLeft: theme.spacing(1)
  },
  pl2: {
    paddingLeft: theme.spacing(2)
  },
  pl3: {
    paddingLeft: theme.spacing(3)
  },
  pl4: {
    paddingLeft: theme.spacing(4)
  },
  pr1: {
    paddingRight: theme.spacing(1)
  },
  pr2: {
    paddingRight: theme.spacing(2)
  },
  pr3: {
    paddingRight: theme.spacing(3)
  },
  pr4: {
    paddingRight: theme.spacing(4)
  },
  root: {
    display: 'flex'
  },
  menuButton: {
    marginRight: 0
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: '0.2s'
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: '0.2s'
    })
  },

  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: '0.2s'
    })
  },
  drawerClose: {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: '0.2s'
    }),

    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7) + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 3,
    padding: theme.spacing(3)
  },
  list: {
    width: 250
  },
  fullList: {
    width: 'auto'
  },
  umlroot: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1)
    }
  },
  rootIcon: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1)
    }
  },

  // Projec App Bar
  projAppBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  projAppBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  projMenuButton: {
    marginRight: theme.spacing(2)
  },
  projDrawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  projDrawerHeader: {
    display: 'flex',
    minHeight: 'initial !important',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end'
  },
  projContent: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  },

  // Admin
  navroot: {
    flexGrow: 1
  },
  navMenuButton: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    padding: 0
  },
  rootProcess: {
    display: 'flex',
    margin: '45px'
  },
  rootHR: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch'
    }
  },
  MuiBadgeDot: {
    color: 'red',
    background: 'red'
  },
  bundDiv: {
    height: '48px',
    margin: 0,
    background: '#080808',
    color: '#eee',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    fontWeight: 400,
    fontSize: '16px',
    textDecoration: 'none',
    letterSpacing: '0.8rem',
    textTransform: 'uppercase'
  },
  navTitle: {
    flexGrow: 1
  },
  paper: {
    height: 140,
    width: 100
  },
  control: {
    padding: theme.spacing(2)
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  processFormControl: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 210
  },
  listStyle: {
    width: '100%',
    maxWidth: 360
  },
  bgroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    '& > *': {
      margin: theme.spacing(1)
    }
  },
  gridStyle: {
    flexGrow: 1
  },
  paperProcess: {
    padding: theme.spacing(1),
    textAlign: 'center'
  },
  previewChip: {
    minWidth: 160,
    maxWidth: 210
  }
}))

export const StyledOnlineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""'
    }
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0
    }
  }
}))(Badge)

export const StyledOfflineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: 'red',
    color: 'red',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '1px solid currentColor',
      content: '""'
    }
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0
    }
  }
}))(Badge)
